module.exports = __webpack_public_path__ + "static/main-700-1ff692911174b55020fc9a0e52a0022c.png";